import angular from 'angular'

import postFlag from '../utils/post-flag'
import StrictObj from '../utils/strict-obj'
import postViewIndex from '../utils/post-view-index'

import { noop, wrap, isNull } from 'lodash-es'

angular
  .module('ggs.gallery')
  .factory('ModalsManager', ModalsManagerProvider)

function ModalsManagerProvider(
  qh,
  $log,
  DefineMethod,
  DefineHandler) {

  return function ModalsManager(
    extFlow,
    postListManager) {

    const sign = 'galleryMain::modalsManager'
    const postList = postListManager.getPostList()

    const manager = StrictObj({
      wrapM: DefineMethod(sign),
      wrapH: DefineHandler(sign)
    })

    manager.wrapM('init', noop)
    manager.wrapM('destroy', noop)

    manager.getPrevModal = (actCurr) => {
      let prevPost = null
      let bestDiff = null

      for (const post of postList) {
        if (!postFlag.isDone(post) || post === actCurr) {
          continue
        }

        const diff = postViewIndex.diffDesc(post, actCurr)
        if (diff > 0) {
          continue
        }

        if (isNull(bestDiff) || Math.abs(diff) < Math.abs(bestDiff)) {
          bestDiff = diff
          prevPost = post
        }
      }

      return prevPost
    }

    manager.getNextModal = (actCurr) => {
      let nextPost = null
      let bestDiff = null

      for (const post of postList) {
        if (!postFlag.isDone(post) || post === actCurr) {
          continue
        }

        const diff = postViewIndex.diffDesc(post, actCurr)
        if (diff < 0) {
          continue
        }

        if (isNull(bestDiff) || Math.abs(diff) < Math.abs(bestDiff)) {
          bestDiff = diff
          nextPost = post
        }
      }

      if (!nextPost) {
        qh.catch(extFlow.flushAppendQueue, wrap(`${sign}#getNextModal: problem in background process`, $log.error))
      }

      return nextPost
    }

    return manager
  }
}
